import { SHOW_MODAL, HIDE_MODAL } from '../mutation-types'

export function showDialog ({ commit }, payload) {
  return commit(SHOW_MODAL, payload)
}
export function hideDialog ({ commit }) {
  return commit(HIDE_MODAL)
}
